import styled from 'styled-components'
import UniverseLink from 'components/UniverseLink/UniverseLinkContainer'
import { breakpointMax } from 'utils/style'

export const RouterLinkStyled = styled(UniverseLink)`
  color: color: #212b44;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    text-decoration: none;
  }
  font-weight: bold;
  margin: 0;
  margin-right: 24px;
`

export const UniverseLinkStyled = styled(UniverseLink)`
  color: color: #212b44;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    text-decoration: none;
  }
  font-weight: bold;
  margin: 0;

  ${breakpointMax('m')`
    display: flex !important;
    justify-content: center;
    left: 0;
    right: 0;
    margin: auto;
  `};
`

export const StyledLink = styled.div`
  a {
    color: #212b44;
  }

  img {
    margin-bottom: 0 !important;
  }

  ${breakpointMax('m')`
  position: fixed;
  left: 23px;
  right: 23px;
  bottom: 0;
  padding: 23px 0px;
  border-top: 1px solid;
  border-color: #E4E9F2;
  top: 290px;
  `};
`
